export const COMPANY = {
  name: 'J&S Empregos LTDA',
  tradingName: 'J&S Empregos LTDA',
  brand: 'J&S Empregos',
  cnpj: '63.251.959/0001-10',
  phone: '(11) 96838-0592',
  email: 'comercial@jsempregos.com.br',
  whatsapp: '5511968380592',
  description:
    'Assessoria em Recursos Humanos, recrutamento, mão de obra temporária e efetiva, terceirização e facilities. Mais eficiência em RH, mais agilidade para sua empresa.',
  tagline: 'Mais eficiência em RH. Mais resultados para sua empresa.',
  address: {
    street: 'Rodovia João Afonso de Souza Castellano',
    number: '411',
    complement: 'Sala n° 04',
    neighborhood: 'Poá',
    city: 'Poá',
    state: 'SP',
    country: 'Brasil',
    zip: '',
  },
  businessAreas: [
    'Recrutamento e Seleção',
    'Mão de Obra Temporária',
    'Mão de Obra Efetiva',
    'Terceirização de Serviços',
    'Assessoria em RH',
    'Limpeza',
    'Segurança Patrimonial',
    'Portaria',
    'Jardinagem e Paisagismo',
    'Zeladoria',
    'Facilities',
  ],
  yearsOfExperience: 15,
  clientsServed: 200,
  professionals: 500,
  citiesCovered: 50,
} as const;

export const NEW_WAVE_URL = 'https://newwavesistemasdigital.netlify.app/';

export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/jstercerizados/',
  facebook: 'https://facebook.com/jsempregos',
  tiktok: 'https://tiktok.com/@jsempregos',
  linkedin: 'https://linkedin.com/company/jsempregos',
  youtube: 'https://youtube.com/@jsempregos',
  twitter: 'https://twitter.com/jsempregos',
  whatsapp: 'https://wa.me/5511968380592',
  email: 'mailto:contato@jsempregos.com.br',
} as const;
